import React from "react";
import styles from "./styles.css";
var LoadingView = function LoadingView() {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.body
  }, /*#__PURE__*/React.createElement("img", {
    src: "https://qa-media-api.xogrp.com/images/34a9d5d3-5d4e-422b-aa46-55fb107d7721",
    alt: "loading-animation"
  }));
};
export default LoadingView;